/**
 * Состав пака «dark-mystic» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 6 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 1 из 6 воронок: palette → ближайшая тема по цветам
    { themeId: 'minimalist-dark', weight: 0.17 },
    // 1 из 6 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.17 },
  ],
  fonts: [
    // 3 из 6 воронок: fontId
    { fontId: 'lora', weight: 0.5 },
    // 2 из 6 воронок: fontId
    { fontId: 'poppins', weight: 0.33 },
  ],
  screenKinds: [
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.500; сюда свёрнуты Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.59 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.100; сюда свёрнуты Q11, Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.12 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.096
    { kind: 'I1', share: 0.11 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.062
    { kind: 'N5', share: 0.07 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.053
    { kind: 'N4', share: 0.06 },
    // средняя доля экранов по 6 воронкам (признаки.json kinds) 0.036
    { kind: 'N1', share: 0.04 },
  ],
  blocks: [
    // в 5 из 6 воронок (признаки.json blocks), подъём 1.85; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 18 из 27, optionIndicatorStyle 18 из 27, optionIndicatorPosition 18 из 27
    {
      type: 'multiple_choice',
      weight: 0.83,
      settings: {
        optionIndicator: 'auto',
        optionIndicatorStyle: 'box',
        optionIndicatorPosition: 'left',
      },
    },
    // в 6 из 6 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 71 из 101, optionIndicator 92 из 101
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 2 из 6 воронок (признаки.json blocks), подъём 5.02
    { type: 'number_input', weight: 0.33, settings: {} },
    // в 3 из 6 воронок (признаки.json blocks), подъём 3.27
    { type: 'height_picker', weight: 0.5, settings: {} },
    // в 3 из 6 воронок (признаки.json blocks), подъём 3.27
    { type: 'weight_picker', weight: 0.5, settings: {} },
    // в 4 из 6 воронок (признаки.json blocks), подъём 1.66
    { type: 'email', weight: 0.67, settings: {} },
    // в 3 из 6 воронок (признаки.json blocks), подъём 1.73
    { type: 'text_field', weight: 0.5, settings: {} },
  ],
  niches: [
    // 2 из 6 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.33 },
  ],
};
